import React from 'react';
import './App.css';
//@ts-ignore
import {Feedbacky} from 'feedbackkyy';
function App() {

  return (
    <body className="App" style={{background:"red"}} >
  <Feedbacky companyId="testCompany"
      modalTitle= "SEND YOUR FEEDBACK"
      sendButtonStyle= {{
        width: "100%",
        outline: "none",
        border: "none",
        borderRadius: "3px",
        color: "white",
        background: "#f27a1a",
        borderColor: "#f27a1a",
        cursor: "pointer",
        padding: "6px 10px",
        fontSize: "14px",
        lineHeight: "18px",
        transition: "all .2s ease",
      }}
      customInputStyle={{
        width: 411,
        height: 150,
        background: "#FBFBFB",
        border: "2px solid rgb(229, 231, 235)",
        borderRadius: "4px",
      }}
   resultTitleCustomStyle= {
   { width: "55%",
    fontSize: "2rem",
    textAlign: "center",
    color: "#047E35",
    fontWeight: "800",}
  }
  customTitle={{color:"green"}}
  />
    </body>
  );
}

export default App;
